import React, { Component } from "react";
import BarraLateral from "../../../../componentes/BarraLateral";
import InputPadrao from "../../../../componentes/Inputs/ImputPadrao";
import BotaoPadrao from "../../../../componentes/Botoes/BotaoPadrao";
//import TooglePadrao from "../../../../componentes/Botoes/TooglePadrao";
import InputDataPadrao from "../../../../componentes/Inputs/InputDataPadrao";
import TituloPagina from "../../../../componentes/TituloPagina";
import TituloCadastroDetalhe from "../../../../componentes/Titulos/TituloCadatrosDetalhe";
import MsgPopUpPadrao from "../../../../componentes/PopUpModal/MsgPopUpPadrao";
import ComboBoxPadrao from "../../../../componentes/ComboBox/ComboboxPadrão"
import ImputNumeroPadrao from "../../../../componentes/Inputs/ImputNumeroPadrao"
//import ContainerFiltro from "../../../../componentes/ContainerFiltro";
import Rodape from "../../../../componentes/Rodape";
import { Global_Retorna_Permissoes, Global_Retorna_Usuario, Global_Valida_Data, Global_Converte_Data } from "../../../../Funcoes_Globais";
import withRouter from "../../../../Rotas/rotasParametros";
import Api from '../../../../servicos/Axios';
import Estilos from "./estilo.module.css";
import PopUpLoadPadrao from '../../../../componentes/PopUpLoad/PopUpLoadPadrao';

//https://www.freecodecamp.org/news/jwt-authentication-in-flask/

class DespesaCadastro extends Component{    
    constructor(props){
        super(props)

        this.state = {
            State_MsgPopUpPadrao_Visivel: false,
            State_MsgPopUpPadrao_Mensagem: '',
            State_MsgPopUpPadrao_Tipo: 1,
            State_MsgPopUpPadrao_Acao: '',
            State_MsgPopUpPadrao_Mostrar_Botoes: true,

            State_LoadPopUpPadrao_Visivel: false,
            State_LoadPopUpPadrao_Mensagem: '',
            
            State_Permissao_Editar: Global_Retorna_Permissoes('config_perm', 'editar'),
            State_Permissao_Ver: Global_Retorna_Permissoes('config_perm', 'ver'),
            State_Permissao_cadastrar: Global_Retorna_Permissoes('config_perm', 'cadastrar'),
            State_Login_Revenda: Global_Retorna_Usuario('login_revenda'),

            state_lista_pcf: [],

            state_status_operacao: this.props.match.paramsLocation.state.status_operacao ,
            state_despesa_id: this.props.match.paramsLocation.state.plano_id,            
            state_despesa_descricao: '',
            state_despesa_valor: 0,
            state_despesa_data: null,
            state_despesa_fk_pcf: 0,
        };

        this.Escolhe_Pcf = this.Escolhe_Pcf.bind(this);
        this.Retorna_Listar_Diversas = this.Retorna_Listar_Diversas.bind(this);
        
        //https://stackoverflow.com/questions/70143135/how-to-use-react-router-dom-v6-navigate-in-class-component
        //O Match pega o parâmetro passado de outra tela pelo link, o navegar navega entre as telas
        //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>");
        //console.log(this.props.match)         
        //console.log(this.props.match.paramsLocation.state.cliente_id);      
        //console.log(this.props.match.paramsLocation.state.status_operacao);

    };

    componentDidMount (){
        this.Funcoes_Iniciais()                  
    };

    Funcoes_Iniciais = async () =>{
        //Precisa esperar o retorno da função Retorna_Listar_Diversas
        await this.Retorna_Listar_Diversas();
        if (this.state.state_status_operacao === 'editar' || this.state.state_status_operacao === 'ver') {
            this.Pesquisar_Despesa();
        }
    }    

    Abre_MsgPopUpPadrao(Tipo = 1, Mostrar_botoes = true, Mensagem = '', Acao_Botao = '', Tempo_fechar = 0){
        this.setState({
            State_MsgPopUpPadrao_Visivel: true,
            State_MsgPopUpPadrao_Tipo: Tipo,
            State_MsgPopUpPadrao_Mensagem: Mensagem,
            State_MsgPopUpPadrao_Acao: Acao_Botao, 
            State_MsgPopUpPadrao_Mostrar_Botoes: Mostrar_botoes,  
        }, () => {
            if (Tempo_fechar > 0){
                setTimeout(
                    this.Fecha_MsgPopUpPadrao.bind(this, 'timer'),
                    Tempo_fechar
                );                
            };
        });
    };

    Fecha_MsgPopUpPadrao(Tipo_botao){
        this.setState({
            State_MsgPopUpPadrao_Visivel: false,               
        }, () => {
            //
        });
    }; 
    
    Abre_LoadPopUpPadrao(mensagem){
        this.setState({
            State_LoadPopUpPadrao_Visivel: true,
            State_LoadPopUpPadrao_Mensagem: mensagem,            
        });
    };

    Fecha_LoadPopUpPadrao(){
        this.setState({
            State_LoadPopUpPadrao_Visivel: false,
            State_LoadPopUpPadrao_Mensagem: '',            
        });
    };    
    
    Retorna_Listar_Diversas(){
        return new Promise((resolve) => {
            var objJson = { 
                retorna_plano_contas_financeiro_saida: true,  
            };
    
            this.Abre_LoadPopUpPadrao('Por favor aguarde ...');
            Api.Executa_chamada(
                this.props.navegar, 'Retorna_Listas_Diversas', 0, JSON.stringify(objJson)
            ).then((resposta) => {
                resolve(true);
                this.Fecha_LoadPopUpPadrao();
                if (resposta.status === 1){
                    //console.log(resposta.dados.revendas)
                    //console.log(resposta.dados)
                    this.setState({
                        state_lista_pcf: resposta.dados.plano_contas_financeiro,
                        state_lista_permissoes: resposta.dados.permissoes,
                    }, function (){
                        if ((resposta.dados.revendas) && (this.state.State_Login_Revenda) && (this.state.state_status_operacao === 'cadastrar')){
                            this.setState({
                                state_clientes_cod_revenda: resposta.dados.revendas[0].codigo
                            })
                        }
                    });
                }else if (resposta.status === 2){
                    this.Abre_MsgPopUpPadrao(3, false, resposta.msg, '', 2000)           
                }
                else{
                    this.Abre_MsgPopUpPadrao(5, false, resposta.msg, '', 5000)
                };           
            });            
        });
    };  

    Pesquisar_Despesa(){
        var objJson = { 
            Pesq_Codigo: this.state.state_despesa_id,
        };
        
        this.Abre_LoadPopUpPadrao('Por favor aguarde ...');
        
        Api.Executa_chamada(
            this.props.navegar, 'Financeiro_Despesa_Detalhe', 0, JSON.stringify(objJson)
        ).then((resposta) => {

            this.Fecha_LoadPopUpPadrao();
            if (resposta.status === 1){
                this.setState({
                    state_despesa_id: resposta.dados.plano.codigo,
                    state_despesa_descricao: resposta.dados.plano.descricao,
                    state_despesa_fk_pcf: resposta.dados.plano.fk_plano_contas_financeiro,
                    state_despesa_data: Global_Converte_Data(resposta.dados.plano.dt_cadastro),
                    state_despesa_valor: resposta.dados.plano.valor,
                }, function (){
                    //
                });
            }else if (resposta.status === 2){
                this.Abre_MsgPopUpPadrao(3, false, resposta.msg, '', 2000)           
            }
            else{
                this.Abre_MsgPopUpPadrao(5, false, resposta.msg, '', 5000)
            };           
        });        
    };

    Salva_Despesa(){
        //valida os campos
        //if (!this.state.state_clientes_tipo_pessoa || this.state.state_clientes_tipo_pessoa === 0){
        //    this.Abre_MsgPopUpPadrao(3, false, 'Tipo de Pessoa Inválida!', '', 1000);
        //    return
        //}

        if (!this.state.state_despesa_descricao || this.state.state_despesa_descricao.trim === ''){
            this.Abre_MsgPopUpPadrao(3, false, 'Descrição inválida!', '', 1000);
            return
        }
        if (!this.state.state_despesa_valor || this.state.state_despesa_valor <= 0){
            this.Abre_MsgPopUpPadrao(3, false, 'Valor inválido!', '', 1000);
            return
        } 
        if (!Global_Valida_Data(this.state.state_despesa_data)) {
            this.Abre_MsgPopUpPadrao(3, false, 'Data Inválida!', '', 1000)
            return;            
        };        
        if (!this.state.state_despesa_fk_pcf || this.state.state_despesa_fk_pcf <= 0){
            this.Abre_MsgPopUpPadrao(3, false, 'Escolha o Plano de Contas!', '', 1000);
            return
        }

        var objJson = { 
            despesa_id: this.state.state_despesa_id,
            despesa_descricao: this.state.state_despesa_descricao,
            despesa_valor: this.state.state_despesa_valor,
            despesa_data: this.state.state_despesa_data,
            despesa_fk_pcf: this.state.state_despesa_fk_pcf,
        };        

        this.Abre_LoadPopUpPadrao('Salvando informações  ...');
        Api.Executa_chamada(
            this.props.navegar, 'Financeiro_Despesa_Atu_Cadastra', 0, JSON.stringify(objJson)
        ).then((resposta) => {
            this.Fecha_LoadPopUpPadrao();
            if (resposta.status === 1){
                if (this.state.state_status_operacao === 'cadastrar'){
                    this.setState({
                        state_despesa_id: resposta.dados.despesa_id,
                        state_status_operacao: 'editar',
                    }, ()=>{
                        this.Pesquisar_Despesa();
                        this.Abre_MsgPopUpPadrao(1, false, 'Despesa cadastrada com sucesso!', '', 1500);
                    });
                }else{
                    this.Abre_MsgPopUpPadrao(1, false, 'Cadastro atualizado com sucesso!', '', 1500);
                }
            }else if (resposta.status === 2){
                this.Abre_MsgPopUpPadrao(3, false, resposta.msg, '', 1500)           
            }
            else{
                this.Abre_MsgPopUpPadrao(5, false, resposta.msg, '', 1500)
            };           
        });        
    }

    Escolhe_Pcf(e){
        e.preventDefault();
        this.setState({
            state_despesa_fk_pcf: parseInt(e.target.value)
        });
    } 
    
    Atualiza_Data(data_str){
        if (Global_Valida_Data(data_str)){
            this.setState({state_despesa_data: data_str});
        }
    };     
        
    render(){
        return(
        <div>
            <MsgPopUpPadrao
                visivel = {this.state.State_MsgPopUpPadrao_Visivel}
                mensagem = {this.state.State_MsgPopUpPadrao_Mensagem}
                tipo = {this.state.State_MsgPopUpPadrao_Tipo}
                mostrar_botoes = {this.state.State_MsgPopUpPadrao_Mostrar_Botoes}
                onclick_btn_ok = {this.Fecha_MsgPopUpPadrao.bind(this, 'ok')}
                onclick_btn_sim = {this.Fecha_MsgPopUpPadrao.bind(this, 'sim')}
                onclick_btn_nao = {this.Fecha_MsgPopUpPadrao.bind(this, 'nao')}
            />
            <PopUpLoadPadrao
                visivel = {this.state.State_LoadPopUpPadrao_Visivel}
                mensagem = {this.state.State_LoadPopUpPadrao_Mensagem}
            />                                 
            <BarraLateral/>
            <div className="GlobalConteinerPrincipal"> 
                <div className="GlobalConteudoPrincipal">

                    <TituloPagina titulo={"Despesas > Cadastro"} />
                    <TituloCadastroDetalhe titulo={"Geral"} />                 
                    <div className={Estilos.ContainerGrid}>
                        <InputPadrao 
                            titulo={'*Descrição'}
                            onChange = {valor => this.setState({state_despesa_descricao: valor.target.value})}
                            value = {this.state.state_despesa_descricao}
                            maxLength = {100}   
                        />
                        <ImputNumeroPadrao
                            titulo = '*Valor'
                            prefix = 'R$ '
                            value={this.state.state_despesa_valor}
                            onValueChange = {valor => this.setState({state_despesa_valor: valor.value})}
                        />
                        <InputDataPadrao 
                            titulo = '*Data'
                            value={this.state.state_despesa_data}
                            onChange={valor => this.Atualiza_Data(valor.target.value)}    
                            //disabled = {(this.state.state_boleto_sincronizado === 'S' || this.state.state_boleto_pagamento_manual === 'S') ? true : false}
                        />                          
                        {
                            this.state.State_Login_Revenda === false ?
                            <ComboBoxPadrao
                                titulo = {'*Plano de Contas'}
                                dica = {'Nenhum'}
                                itens = {this.state.state_lista_pcf}
                                onChange = {this.Escolhe_Pcf}
                                select_value = {this.state.state_despesa_fk_pcf}
                            />
                            : null
                        }                                                                       
                    </div>                                    
                    <div className={Estilos.ConteinerBotoes} >
                        <BotaoPadrao 
                            tipo={"voltar"} 
                            descricao={"Voltar"} 
                            onClick={() =>{this.props.navegar(-1)}} 
                        />

                        {
                            ((this.state.State_Permissao_Editar || this.state.State_Permissao_cadastrar) && (this.state.state_status_operacao === 'editar' || this.state.state_status_operacao === 'cadastrar')) ?
                            <BotaoPadrao
                                tipo={"salvar"} 
                                descricao={"Salvar"} 
                                onClick={() =>{this.Salva_Despesa()}} 
                            />
                            : null
                        }                 
                    </div>                                                                                                   
                </div>
            </div>
            <Rodape/>
        </div>            
        );
    };
};

export default withRouter(DespesaCadastro);